module.exports = __webpack_public_path__ + "img/Dateold.45bf0c09.svg";